import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"
import $ from "jquery"

import {
  VALUATION_PAGE_URL,
  BRANCHES_PAGE_URL,
  ABOUT_PAGE_URL,
  PROPERTY_SERVICES_PAGE_URL,
  AREA_GUIDE_PAGE_URL,
  LATEST_NEWS_PAGE_URL,
  PROPERTY_MANAGEMENT_PAGE_URL,
  TESTIMONIALS_PAGE_URL,
  MORTGAGES_PAGE_URL,
} from "../../common/site/constants"

const PopularSearchDynamic = props => {
  //Get values from refine search
  const [ptype, setPtype] = useState(false)
  const [searchbed, setsearchbed] = useState(false)

  var searchaction = ""
  var URL = ""
  var ptypeURL = ""
  var bedURL = ""
  var bedtypeText = ""
  var area = "Kent"
  var typeText = "Property"
  var searcharea = ""
  var searchareaText = ""
  var slug_text = ""
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
  if (props.searchtype == "sales") {
    searchaction = "for Sale"
    URL = "/property/for-sale/"
  }
  if (props.searchtype == "lettings") {
    searchaction = "to Rent"
    URL = "/property/to-rent/"
  }
  if (props.searchtype == "newhomesales") {
    searchaction = "for Sale"
    URL = "/property/new-homes/for-sale/"
    typeText = "New homes"
  }
  if (props.searchtype == "newhomerentals") {
    searchaction = "to Rent"
    URL = "/property/new-homes/to-rent/"
    typeText = "New Property"
  }
  if (props.searchPtype) {
    ptypeURL = "/type-" + props.searchPtype
    typeText = capitalizeFirstLetter(props.searchPtype).replace(
      "Buy-to-let-investments",
      "Buy to let investments"
    )
  }
  if (props.searchBedroomfield) {
    bedtypeText = props.searchBedroomfield + " Bedroom " + typeText
    bedURL = "/" + props.searchBedroomfield + "-and-more-bedrooms"
  }
  //console.log("$$$$", props.Searcharea && props.Searcharea.areas !='undefined' && props.Searcharea.areas)
  if (props.Searcharea && props.Searcharea != "undefined") {
    searcharea = props.Searcharea.replace("in ", "").replace(",", "")
    searchareaText = props.Searcharea.replace(/%20/g, " ").replace("in ", "")
    slug_text = searcharea.replace(/\s/g, "-")
  }
  return (
    <Row>
      {props.searchBedroomfield ? (
        <Col md={6} lg={3} className="properties-info">
          <ul>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "maidstone-kent")
                  localStorage.setItem("searchValueFull", "maidstone-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-maidstone-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Maidstone
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "gillingham-kent")
                  localStorage.setItem("searchValueFull", "gillingham-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-gillingham-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Gillingham
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "dartford-kent")
                  localStorage.setItem("searchValueFull", "dartford-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-dartford-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Dartford
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "ashford-kent")
                  localStorage.setItem("searchValueFull", "ashford-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-ashford-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Ashford
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "canterbury-kent")
                  localStorage.setItem("searchValueFull", "canterbury-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-canterbury-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Canterbury
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "folkestone-kent")
                  localStorage.setItem("searchValueFull", "folkestone-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-folkestone-kent${ptypeURL}${bedURL}/radius-3-miles/`}
              >
                {bedtypeText} {searchaction} in Folkestone
              </a>
            </li>
          </ul>
        </Col>
      ) : (
        <Col md={6} lg={3} className="properties-info">
          <ul>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "maidstone-kent")
                  localStorage.setItem("searchValueFull", "maidstone-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-maidstone-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Maidstone
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "gillingham-kent")
                  localStorage.setItem("searchValueFull", "gillingham-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-gillingham-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Gillingham
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "dartford-kent")
                  localStorage.setItem("searchValueFull", "dartford-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-dartford-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Dartford
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "ashford-kent")
                  localStorage.setItem("searchValueFull", "ashford-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-ashford-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Ashford
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "canterbury-kent")
                  localStorage.setItem("searchValueFull", "canterbury-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-canterbury-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Canterbury
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", "folkestone-kent")
                  localStorage.setItem("searchValueFull", "folkestone-kent")
                }}
                className="footer_scroll_top"
                href={`${URL}in-folkestone-kent${ptypeURL}/radius-3-miles/`}
              >
                {typeText} {searchaction} in Folkestone
              </a>
            </li>
          </ul>
        </Col>
      )}

      {searcharea ? (
        <Col md={6} lg={3} className="properties-info">
          {props.searchBedroomfield ? (
            <ul>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "maidstone-kent")
                    localStorage.setItem("searchValueFull", "maidstone-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-maidstone-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Maidstone
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "gillingham-kent")
                    localStorage.setItem("searchValueFull", "gillingham-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-gillingham-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Gillingham
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "dartford-kent")
                    localStorage.setItem("searchValueFull", "dartford-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-dartford-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Dartford
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "ashford-kent")
                    localStorage.setItem("searchValueFull", "ashford-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-ashford-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Ashford
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "canterbury-kent")
                    localStorage.setItem("searchValueFull", "canterbury-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-canterbury-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Canterbury
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", "folkestone-kent")
                    localStorage.setItem("searchValueFull", "folkestone-kent")
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-folkestone-kent${ptypeURL}/radius-3-miles/`}
                >
                  {typeText} {searchaction} in Folkestone
                </a>
              </li>
            </ul>
          ) : props.searchPtype ? (
            <ul>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/1-and-more-bedrooms/radius-3-miles/`}
                >
                  1 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/2-and-more-bedrooms/radius-3-miles/`}
                >
                  2 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/3-and-more-bedrooms/radius-3-miles/`}
                >
                  3 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/4-and-more-bedrooms/radius-3-miles/`}
                >
                  4 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/5-and-more-bedrooms/radius-3-miles/`}
                >
                  5 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/6-and-more-bedrooms/radius-3-miles/`}
                >
                  6 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
            </ul>
          ) : (
            <ul>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/1-and-more-bedrooms/radius-3-miles/`}
                >
                  1 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/2-and-more-bedrooms/radius-3-miles/`}
                >
                  2 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/3-and-more-bedrooms/radius-3-miles/`}
                >
                  3 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/4-and-more-bedrooms/radius-3-miles/`}
                >
                  4 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/5-and-more-bedrooms/radius-3-miles/`}
                >
                  5 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    localStorage.setItem("searchValue", slug_text)
                    localStorage.setItem("searchValueFull", slug_text)
                  }}
                  className="footer_scroll_top"
                  href={`${URL}in-${searcharea.replace(
                    /\s/g,
                    "-"
                  ).toLowerCase()}/6-and-more-bedrooms/radius-3-miles/`}
                >
                  6 Bedroom Property {searchaction} in{" "}
                  {capitalizeFirstLetter(searchareaText)}
                </a>
              </li>
            </ul>
          )}
        </Col>
      ) : (
        <Col md={6} lg={3} className="properties-info">
          <ul>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", slug_text)
                  localStorage.setItem("searchValueFull", slug_text)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/1-and-more-bedrooms/radius-3-miles/`}
              >
                1 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", slug_text)
                  localStorage.setItem("searchValueFull", slug_text)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/2-and-more-bedrooms/radius-3-miles/`}
              >
                2 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", searcharea)
                  localStorage.setItem("searchValueFull", searcharea)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/3-and-more-bedrooms/radius-3-miles/`}
              >
                3 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", slug_text)
                  localStorage.setItem("searchValueFull", slug_text)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/4-and-more-bedrooms/radius-3-miles/`}
              >
                4 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", slug_text)
                  localStorage.setItem("searchValueFull", slug_text)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/5-and-more-bedrooms/radius-3-miles/`}
              >
                5 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  localStorage.setItem("searchValue", slug_text)
                  localStorage.setItem("searchValueFull", slug_text)
                }}
                className="footer_scroll_top"
                href={`${URL}in-${searcharea.replace(
                  /\s/g,
                  "-"
                ).toLowerCase()}/6-and-more-bedrooms/radius-3-miles/`}
              >
                6 Bedroom Property {searchaction} in{" "}
                {capitalizeFirstLetter(searchareaText)}
              </a>
            </li>
          </ul>
        </Col>
      )}

      <Col md={6} lg={3} className="properties-info">
        <ul>
          <li>
            <a
              onClick={() => {
                localStorage.setItem("searchValue", "kent")
                localStorage.setItem("searchValueFull", "kent")
              }}
              className="footer_scroll_top"
              href={`${URL}in-kent/type-apartment/`}
            >
              Apartments {searchaction} in {area}
            </a>
          </li>
          <li>
            <a
              onClick={() => {
                localStorage.setItem("searchValue", "kent")
                localStorage.setItem("searchValueFull", "kent")
              }}
              className="footer_scroll_top"
              href={`${URL}in-kent/type-flats/`}
            >
              Flats {searchaction} in {area}
            </a>
          </li>
          <li>
            <a
              onClick={() => {
                localStorage.setItem("searchValue", "kent")
                localStorage.setItem("searchValueFull", "kent")
              }}
              className="footer_scroll_top"
              href={`${URL}in-kent/type-house/`}
            >
              Houses {searchaction} in {area}
            </a>
          </li>
          <li>
            <a
              onClick={() => {
                localStorage.setItem("searchValue", "kent")
                localStorage.setItem("searchValueFull", "kent")
              }}
              className="footer_scroll_top"
              href={`${URL}in-kent/type-bungalow/`}
            >
              Bungalows {searchaction} in {area}
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${MORTGAGES_PAGE_URL.alias}`}
            >
              Mortgage brokers in {capitalizeFirstLetter(searchareaText)}
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${TESTIMONIALS_PAGE_URL.alias}`}
            >
              Testimonials
            </a>
          </li>
        </ul>
      </Col>

      <Col md={6} lg={3} className="properties-info">
        <ul>
          <li>
            <a
              className="footer_scroll_top"
              href={`${AREA_GUIDE_PAGE_URL.alias}`}
            >
              {capitalizeFirstLetter(searchareaText)} Area Guides
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${BRANCHES_PAGE_URL.alias}/`}
            >
              Estate Agents in {capitalizeFirstLetter(searchareaText)}
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${VALUATION_PAGE_URL.alias}`}
            >
              Property valuation in {capitalizeFirstLetter(searchareaText)}
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${PROPERTY_MANAGEMENT_PAGE_URL.alias}`}
            >
              Property management in {capitalizeFirstLetter(searchareaText)}
            </a>
          </li>
          <li>
            <a className="footer_scroll_top" href={`${ABOUT_PAGE_URL.alias}`}>
              About Wards of Kent estate agents
            </a>
          </li>
          <li>
            <a
              className="footer_scroll_top"
              href={`${LATEST_NEWS_PAGE_URL.alias}/`}
            >
              Latest Property News
            </a>
          </li>
        </ul>
      </Col>
    </Row>
  )
}

export default PopularSearchDynamic
